var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.041 512.041",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M464.956 208.936C464.956 93.544 371.413 0 256.021 0 140.628 0 47.084 93.544 47.084 208.936c0 22.883-4.57 45.496-13.081 66.736-7.934 19.799-12.3 41.411-12.3 64.045 0 95.171 77.152 172.323 172.323 172.323h123.989c95.171 0 172.323-77.152 172.323-172.323 0-22.634-4.367-44.246-12.3-64.045-8.512-21.24-13.082-43.853-13.082-66.736z",
    opacity: 1,
    "data-original": "#326b82",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M464.957 208.936C464.957 93.544 371.413 0 256.021 0l-.062.001v512.04h62.057c95.172 0 172.323-77.152 172.323-172.323 0-22.634-4.367-44.246-12.3-64.045-8.513-21.241-13.082-43.854-13.082-66.737z",
    opacity: 1,
    "data-original": "#0c475b",
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.282,
    cy: 193.007,
    fill: "#000000",
    rx: 25.672,
    ry: 33.393,
    opacity: 1,
    "data-original": "#062842",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefafa",
    d: "M129.282 242.334c-11.746 0-22.967-5.833-30.786-16.003-6.978-9.076-10.82-20.911-10.82-33.324s3.843-24.248 10.82-33.324c7.819-10.17 19.04-16.003 30.786-16.003s22.968 5.833 30.786 16.003c6.979 9.076 10.821 20.911 10.821 33.324s-3.843 24.248-10.821 33.324c-7.819 10.17-19.041 16.003-30.786 16.003zm0-66.785c-3.97 0-9.736 6.801-9.736 17.458 0 10.656 5.766 17.458 9.736 17.458s9.737-6.801 9.737-17.458-5.767-17.458-9.737-17.458z",
    opacity: 1,
    "data-original": "#ffb139",
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.001,
    cy: 193.007,
    fill: "#000000",
    rx: 25.672,
    ry: 33.393,
    opacity: 1,
    "data-original": "#001e2a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M386.001 242.334c-11.746 0-22.968-5.833-30.786-16.003-6.979-9.076-10.821-20.911-10.821-33.324s3.843-24.248 10.821-33.324c7.818-10.17 19.04-16.003 30.786-16.003s22.967 5.833 30.786 16.003c6.978 9.076 10.82 20.911 10.82 33.324s-3.843 24.248-10.82 33.324c-7.819 10.17-19.04 16.003-30.786 16.003zm0-66.785c-3.97 0-9.737 6.801-9.737 17.458 0 10.656 5.767 17.458 9.737 17.458s9.736-6.801 9.736-17.458c.001-10.657-5.766-17.458-9.736-17.458z",
    opacity: 1,
    "data-original": "#ff8d61",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m177.843 321.104 43.949 82.026a119.546 119.546 0 0 1 11.697 32.372l1.287 6.275a20.952 20.952 0 0 0 20.525 16.742c10.277 0 19.037-7.454 20.682-17.598a119.58 119.58 0 0 1 14.615-42.137l44.152-76.858z",
    opacity: 1,
    "data-original": "#ffca00",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefafa",
    d: "M255.958 458.519c9.989-.312 18.415-7.642 20.025-17.568a119.58 119.58 0 0 1 14.615-42.137l44.152-76.858-78.791-.413v136.976z",
    opacity: 1,
    "data-original": "#ffb139",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "M340.381 296.758c-1.576-20.853-18.62-37.614-39.494-38.879-19.158-1.16-35.77 10.257-42.117 26.922a3.095 3.095 0 0 1-2.898 1.982 3.1 3.1 0 0 1-2.919-2.038c-5.793-16.032-20.663-26.824-38.661-26.951-21.66-.152-40.569 16.648-42.568 38.216-2.33 25.143 17.395 46.275 42.055 46.275l.424-.002c4.309-.044 8.127 2.546 9.798 6.519 5.256 12.5 17.61 21.278 32.02 21.278 14.425 0 26.789-8.796 32.037-21.316 1.655-3.95 5.449-6.53 9.731-6.481.158.002.316.003.475.003 24.414-.001 43.992-20.715 42.117-45.528z",
    opacity: 1,
    "data-original": "#fafafa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "M300.887 257.874c-19.158-1.16-35.77 10.257-42.117 26.922a3.09 3.09 0 0 1-2.811 1.975v83.301l.062.002c14.425 0 26.789-8.796 32.036-21.316 1.656-3.95 5.449-6.53 9.731-6.481.158.002.316.003.475.003 24.415 0 43.993-20.714 42.118-45.527-1.576-20.854-18.62-37.615-39.494-38.879z",
    opacity: 1,
    "data-original": "#e2edf2",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.662c7d634f7041c4ea23be5eea4f0f25.svg";
export { ForwardRef as ReactComponent };